import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useTranslation } from '../../../contexts/translation-context';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const FullNameLastNameWUT = props => {
  const fieldType = FIELD_TYPES.FULL_NAME_LAST_NAME;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    label: t('locale-dataset.addressParts.default.lastName')
  }));
};
//# sourceMappingURL=full-name-last-name-wut.js.map